import { jsxs as a, Fragment as h, jsx as l } from "react/jsx-runtime";
import { useState as v, useEffect as k } from "react";
import { Backdrop as x } from "../Backdrop/Backdrop.js";
import { Button as r } from "../Button/Button.js";
import { classnames as i } from "../utils/classnames.js";
import '../../assets/Modal.css';function w({
  open: e,
  onClose: m,
  disableActionButton: d,
  disableCloseButton: c,
  displayCloseButton: f = !0,
  displayActionButton: u = !1,
  labelActionButton: b = "Action",
  labelCloseButton: p = "Close",
  children: C,
  onAction: t
}) {
  const [o, n] = v(e);
  k(() => {
    n(e);
  }, [e]);
  const s = () => {
    n(!1), setTimeout(m, 250);
  };
  return /* @__PURE__ */ a(h, { children: [
    /* @__PURE__ */ l(x, { open: o, onClose: s }),
    /* @__PURE__ */ a(
      "div",
      {
        className: i(
          ["modal"],
          ["modal--internalOpen", o],
          ["modal--open", e]
        ),
        children: [
          /* @__PURE__ */ l("div", { className: "modal-body", children: e && C }),
          /* @__PURE__ */ a(
            "div",
            {
              className: i(
                ["modal-buttons--between", !!t],
                ["modal-buttons--center", !t]
              ),
              children: [
                f && /* @__PURE__ */ l(
                  r,
                  {
                    label: p,
                    variant: "outline",
                    onClick: s,
                    disabled: c
                  }
                ),
                u && /* @__PURE__ */ l(
                  r,
                  {
                    label: b,
                    onClick: t,
                    disabled: d
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
}
export {
  w as Modal
};
//# sourceMappingURL=Modal.js.map
